import { render, staticRenderFns } from "./Paginas.vue?vue&type=template&id=2c791a0a&"
import script from "./Paginas.vue?vue&type=script&lang=js&"
export * from "./Paginas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Paginas.vue"
export default component.exports